import { render, staticRenderFns } from "./Destinationcustom.vue?vue&type=template&id=4ad20432"
import script from "./Destinationcustom.vue?vue&type=script&setup=true&lang=js"
export * from "./Destinationcustom.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Destinationcustom.vue?vue&type=style&index=0&id=4ad20432&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports